import React, { useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import Modal from './Modal';
import { CustomTextField } from '../Textfield';

const ReadOnlyRow = ({ label, value }) => (
    <Box display="flex" flexDirection="column" style={{ marginBottom: 12 }}>
        <Typography style={{ fontSize: 12, color: '#4c4e64', fontWeight: 500 }}>
            {label}
        </Typography>
        <Typography style={{ fontSize: 14, color: '#14112d', fontWeight: 700 }}>
            {value || '--'}
        </Typography>
    </Box>
);

// Retrigger BGV after an INSUFFICIENT / INITIATION_FAILED result. Address is operator-entered; name/contact/DOB
// are shown read-only from page data (DOB from the Aadhaar doc). Only { userId, address } is sent — the backend
// backfills the rest from the stored user/userInfo (same source the automatic BD BGV uses).
export default function RetriggerBGVModal({
    open,
    onClose,
    loading,
    name,
    contactNumber,
    dob,
    showDob = true,
    defaultAddress = '',
    showFatherName = false,
    defaultFatherName = '',
    onSubmit,
    title = 'Retrigger Background Verification',
}) {
    const [address, setAddress] = useState(defaultAddress);
    const [fatherName, setFatherName] = useState(defaultFatherName);

    const trimmedAddress = (address || '').trim();

    const actions = [
        <Button key="cancel" onClick={onClose} disabled={loading}>
            Cancel
        </Button>,
        <Button
            key="submit"
            variant="contained"
            style={{ background: '#43419E', color: '#fff' }}
            disabled={loading || !trimmedAddress}
            onClick={() => onSubmit(trimmedAddress, (fatherName || '').trim())}
        >
            Initiate BGV
        </Button>,
    ];

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={title}
            actions={actions}
            loading={loading}
        >
            <ReadOnlyRow label="Name" value={name} />
            <ReadOnlyRow label="Contact Number" value={contactNumber} />
            {showDob && <ReadOnlyRow label="Date of Birth" value={dob} />}

            <CustomTextField
                fullWidth
                multiline
                rows={3}
                isRequired
                label="Address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
            />
            {showFatherName && (
                <Box mt={2}>
                    <CustomTextField
                        fullWidth
                        label="Father's Name"
                        value={fatherName}
                        onChange={(e) => setFatherName(e.target.value)}
                    />
                </Box>
            )}
        </Modal>
    );
}
